
import { Outlet } from "react-router-dom";
import Header from "../../components/Header";

function Dashboard() {
  return (
    <>
      <Header />

      <div style={{ padding: "20px" }}>
        <Outlet />
      </div>
    </>
  );
}

export default Dashboard;